import { createConsumer } from '@rails/actioncable';

const PRESENCE_INTERVAL = 20000;
const RECONNECT_INTERVAL = 1000;

class BaseActionCableConnector {
  static isDisconnected = false;

  constructor(app, pubsubToken, websocketHost = '') {
    const websocketURL = websocketHost ? `${websocketHost}/cable` : undefined;

    this.app = app;
    this.pubsubToken = pubsubToken;
    this.websocketURL = websocketURL;

    this.consumer = createConsumer(websocketURL);
    this.events = {};
    this.reconnectTimer = null;

    this.isAValidEvent = () => true;

    this.createSubscription();

    this.triggerPresenceInterval = () => {
      setTimeout(() => {
        this.subscription?.updatePresence();
        this.triggerPresenceInterval();
      }, PRESENCE_INTERVAL);
    };
    this.triggerPresenceInterval();
  }

  createSubscription() {
    this.subscription = this.consumer.subscriptions.create(
      {
        channel: 'RoomChannel',
        pubsub_token: this.pubsubToken,
        account_id: this.app.$store.getters.getCurrentAccountId,
        user_id: this.app.$store.getters.getCurrentUserID,
      },
      {
        connected: () => {
          BaseActionCableConnector.isDisconnected = false;
          this.clearReconnectTimer();
        },

        updatePresence() {
          this.perform('update_presence');
        },
        received: this.onReceived,
        disconnected: () => {
          BaseActionCableConnector.isDisconnected = true;
          this.onDisconnected();
          this.initReconnectTimer();
        },
      }
    );
  }


  checkConnection() {
    if (BaseActionCableConnector.isDisconnected) {
      this.clearReconnectTimer();
      this.onReconnect();
      BaseActionCableConnector.isDisconnected = false;
    } else {
      this.initReconnectTimer();
    }
  }

  clearReconnectTimer = () => {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
  };

  initReconnectTimer = () => {
    this.clearReconnectTimer();
    this.reconnectTimer = setTimeout(() => {
      this.checkConnection();
    }, RECONNECT_INTERVAL);
  };

  onReconnect = () => {
    try {
      if (this.consumer.connection.isOpen()) return;

      this.consumer.disconnect();

      this.consumer = createConsumer(this.websocketURL);

      this.createSubscription();

    } catch (error) {
      BaseActionCableConnector.isDisconnected = true;
      this.initReconnectTimer();
    }
  };

  // eslint-disable-next-line class-methods-use-this
  onDisconnected = () => {};

  disconnect() {
    this.consumer.disconnect();
  }

  onReceived = ({ event, data } = {}) => {
    if (this.isAValidEvent(data)) {
      if (this.events[event] && typeof this.events[event] === 'function') {
        this.events[event](data);
      }
    }
  };
}

export default BaseActionCableConnector;
